<template>
  <div>
    <a-button
      class="approval-btn-void"
      :loading="loading"
      type="primary"
      :disabled="isDisabled"
      danger
      @click="showDialog"
    >
      作废
    </a-button>

    <a-modal
      :confirmLoading="loading"
      v-model:visible="visible"
      title="输入作废原因"
      @ok="handleOk"
    >
      <div class="approval-dialog__subtitle">（必填）</div>
      <a-textarea
        show-count
        v-model:value="approvalContent"
        placeholder="请输入作废原因，最多200字"
        :auto-size="{ minRows: 3 }"
        :maxlength="200"
        allowClear
      />
    </a-modal>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs } from "vue";
import { ApprovalFlowService } from "../approval-flow.service";
import { message } from "ant-design-vue";
import { number } from "echarts";
import { useFlowEmitter } from "@/utils/emitter";
export default defineComponent({
  name: "submit-approval-btn",
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    bizName: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
    },
  },
  emits: ["refresh", "update:loading"],
  setup(props, { emit }) {
    const { emitEvent } = useFlowEmitter();
    const state = reactive({
      visible: false,
      approvalContent: "",
    });
    const showDialog = () => {
      state.visible = true;
    };
    const { run, loading } = ApprovalFlowService.useVoidApi();
    const handleOk = async () => {
      if (!state.approvalContent) {
        message.warning("请填写作废原因");
        return;
      }
      try {
        emit("update:loading", true);
        const { bizId, bizType, bizName } = props;
        const data = {
          bizId,
          bizType,
          bizName,
          remark: state.approvalContent,
        };
        let res = await run(data);
        if (res.respCode !== "0000") {
          // message.error(res.respDesc);
          return;
        }
        emitEvent(bizId);
        message.success(res.respDesc);
        emit("refresh", null);
        state.visible = false;
      } finally {
        emit("update:loading", false);
      }
    };
    return {
      ...toRefs(state),
      showDialog,
      handleOk,
      loading,
    };
  },
});
</script>

<style scoped>
.approval-dialog__subtitle {
  color: #6d6d6d;
  position: absolute;
  top: 16px;
  left: 128px;
  font-size: 14px;
}
</style>
